import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 11867345-3F46-40E5-91A4-4EBBE393226D
 * name swap-horizontal-circle
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-horizontal-circle.svg
 * tags
 * - Arrow 
 */
export const SwapHorizontalCircleIcon = createSvgIcon(<><path d="M22 12C22 6.5 17.5 2 12 2S2 6.5 2 12 6.5 22 12 22 22 17.5 22 12M15 6.5L18.5 10L15 13.5V11H11V9H15V6.5M9 17.5L5.5 14L9 10.5V13H13V15H9V17.5Z" /></>, 'SwapHorizontalCircleIcon');
export default SwapHorizontalCircleIcon